export default "__VITE_ASSET__Dr6qUcm6__"